import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import './FencePagination.scss';

interface FencePaginationProps {
  currentPage: number;
  totalPages: number;
  itemsPerPage?: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

const FencePagination: React.FC<FencePaginationProps> = ({
  currentPage,
  totalPages,
  itemsPerPage = 12,
  totalItems,
  onPageChange
}) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [pageInput, setPageInput] = React.useState('');

  if (totalItems <= itemsPerPage) {
    return null;
  }

  const handleDialogOpen = () => {
    setPageInput(currentPage.toString());
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handlePageJump = () => {
    const pageNum = parseInt(pageInput, 10);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
      onPageChange(pageNum);
      setDialogOpen(false);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPageInput(event.target.value);
  };

  return (
    <>
      <div className="FencePagination">
        <button
          className="FencePagination-Button"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>

        <span
          className="FencePagination-Info clickable"
          onClick={handleDialogOpen}
          title="Click to select page"
        >
          {currentPage} / {totalPages}
        </span>

        <button
          className="FencePagination-Button"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>

      {/* Modal for page selection */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        maxWidth="xs"
        fullWidth
        className="FencePagination-Dialog"
      >
        <DialogTitle className="FencePagination-DialogTitle">Choose page</DialogTitle>
        <DialogContent className="FencePagination-DialogContent">
          <TextField
            autoFocus
            margin="dense"
            label="Page number"
            type="number"
            fullWidth
            variant="outlined"
            value={pageInput}
            onChange={handleInputChange}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handlePageJump();
              }
            }}
            inputProps={{
              min: 1,
              max: totalPages
            }}
            className="FencePagination-TextField"
          />
          <div style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
            Total pages: {totalPages}
          </div>
        </DialogContent>
        <DialogActions className="FencePagination-DialogActions">
          <Button onClick={handleDialogClose} className="FencePagination-DialogButton Cancel">
            Cancel
          </Button>
          <Button
            onClick={handlePageJump}
            className="FencePagination-DialogButton Primary"
            disabled={!pageInput || parseInt(pageInput, 10) < 1 || parseInt(pageInput, 10) > totalPages}
          >
            Go
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FencePagination;